import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMessageCircle } = FiIcons;

function MobileActionBar() {
  return (
    <div className="mobile-action-bar" aria-label="Quick contact actions">
      <a href="tel:0433037815"><SafeIcon icon={FiPhone} /> Call Milan</a>
      <a href="https://wa.me/61433037815"><SafeIcon icon={FiMessageCircle} /> Text / WhatsApp</a>
    </div>
  );
}

export default MobileActionBar;